import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { HEALTH_LIST_LIMIT } from '@mahallu/shared';
import { loadErrorKey, useDataHealth } from '../api';
import { Badge, PageHeader } from '../components/Parts';

/** Register › Data health (pilot slice 6): records that break a register rule or are worth a look. */
export function DataHealth() {
  const { t } = useTranslation();
  const health = useDataHealth();
  const checks = health.data;
  const toFix = checks?.filter((c) => c.level === 'fix').reduce((n, c) => n + c.count, 0) ?? 0;
  return (
    <>
      <PageHeader icon="shield" title={t('health.title')} desc={t('health.desc')} />
      {health.isError ? <p className="form-error">{t(loadErrorKey(health.error))}</p> : null}
      {!checks ? (
        health.isError ? null : <p className="note">{t('health.loading')}</p>
      ) : (
        <>
          <div className="callout" role="status" style={{ marginBottom: 14 }}>
            {toFix ? t('health.toFix', { n: toFix }) : t('health.allClear')}
          </div>
          <div className="privacy-grid">
            {checks.map((c) => (
              <section key={c.check} className="card">
                <div className="section-h">
                  <h2>{t(`health.${c.check}`)}</h2>
                  <Badge tone={c.count === 0 ? 'ok' : c.level === 'fix' ? 'bad' : 'warn'}>{c.count}</Badge>
                  <span className="note">{c.level === 'fix' ? t('health.levelFix') : t('health.levelReview')}</span>
                </div>
                <p className="note">{t(`health.${c.check}.why`)}</p>
                {c.items.length ? (
                  <ul className="history">
                    {c.items.map((i) => (
                      <li key={`${i.houseId}-${i.memberName ?? ''}`}>
                        <Link to={`/register/members?house=${encodeURIComponent(i.houseId)}`}>
                          <span className="num">{i.houseNo}</span> · {i.houseName}
                        </Link>
                        {i.memberName ? ` · ${i.memberName}` : ''}
                      </li>
                    ))}
                  </ul>
                ) : null}
                {c.count > c.items.length ? <p className="note">{t('health.more', { n: c.count - c.items.length, limit: HEALTH_LIST_LIMIT })}</p> : null}
              </section>
            ))}
          </div>
        </>
      )}
    </>
  );
}
